module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading.shift":"Shift"},"es":{}}')
  delete Component.options._Ctor
}
